export enum BadgeEnum {
  PAGE_LOADS, UNIQUE, ORGANIC, PATH, TITLE, REFERRER, HEATMAP
}
